import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatFileName(fileName: string): string {
  const extensionIndex = fileName.lastIndexOf('.');
  const name = fileName
      .slice(0, extensionIndex)
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/gi, '')
      .toLowerCase();
  const extension = fileName.slice(extensionIndex + 1).toLowerCase();
  const timestamp = Date.now(); // Add current timestamp
  return `${name}-${timestamp}.${extension}`;
}
